import { ReturnStruct } from "../../structs/return.struct";
import { CorreiosEstimate } from "./kit-details.response";

export class KitDetailsCorreiosEstimateResponse extends ReturnStruct{
  listCorreiosEstimates:CorreiosEstimate[];
}